import React from "react";
import CustomChip from "../general/chips";

const FilterDeadlinesChips = ({selectedItems, onRemoveSelectedItems, key}) => {
  let chips = [];
  for (let item in selectedItems) {
    if (selectedItems.hasOwnProperty(item)) {
      chips.push(<CustomChip
        key={`${key}_${item}`}
        closable="true"
        onClose={() => onRemoveSelectedItems(item)}
        style={{
          marginTop: "10px",
          width: "max-content",
          maxWidth: 400,
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          overflow: "hidden"
        }}
        description={selectedItems[item]}
      />);
    }
  }
  return (
    <div style={{ flex: "0 1 auto", width: "100%" }}>
      <div style={{ display: "flex", flexWrap: "wrap", padding: 5 }}>
        {chips}
      </div>
    </div>
  );

};

export default FilterDeadlinesChips;
